module.exports = __webpack_public_path__ + "static/media/21ECLAC5.85a8238d.jpg";